import React from 'react';
import { InlineMenu } from '@uncinc/uncinc-react-kitchen-sink';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from "../Button";
import useVacancyApplication from '../../helpers/useVacancyApplication';
import VacancyDetailsCta from '../VacancyDetailsCta';
import CampaignDetailsCta from '../CampaignDetailsCta';

import Container from '../Container';

import './style.scss';

const StickyCTA = ({ childEntity, type }) => { // onVacancyApply, whatsappLink

  const { t } = useTranslation();
  const { handleApply } = useVacancyApplication(childEntity.toJS());


  const generateMenuItems = () => {
    const items = [];
    const paragraphs = childEntity.get('field_vacancy_detail');

    // Intro items
    items.push({
      menuItemName: childEntity.getIn(['title', '0', 'value']),
      elementId: 'vacancy-details',
      activeByDefault: true,
    });

    if(type === 'vacancy') {
      // Paragraph items
      paragraphs.map((paragraph, index) => {
        const linkName = paragraph.getIn(['entity', 'field_link_name', '0', 'value']);
        items.push({
          menuItemName: linkName,
          elementId: `paragraph--${index}`,
        });
      });
    }

    return items;
  };

  return (
    <div className="StickyCTA" data-type={type}>
      <Container>
        {type === 'vacancy' && (
          <Link
            onClick={() => window.scrollTo({
              top: 0,
              behavior: 'smooth',
            })}
            to="/vacatures"
            className="StickyCTA__back-button icon-before icon-keyboard_arrow_left_400"
          >
            {t('vacancies')}
          </Link>
        )}


        <div className='StickyCTA__buttons'>
          <InlineMenu
            items={generateMenuItems()}
            scrollToTopOffset={200}
          />
          {type === 'vacancy' && (
            <VacancyDetailsCta
              onVacancyApply={handleApply}
              onlyShowOn="desktop"
            />
          )}

        {type === 'campaign_page' && (
          <CampaignDetailsCta formTriggerLabel={childEntity.getIn(['field_call_to_action_label', '0', 'value'])} secondaryLink={{label: childEntity.getIn(['field_primairy_link', '0', 'title']), uri: childEntity.getIn(['field_primairy_link', '0', 'uri'])}} />
        )}

        </div>
      </Container>
    </div>
  );
};

export default StickyCTA;
